module.exports = __webpack_public_path__ + "img/4.dbf77cd2.png";